import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import {
    Geofence,
    PlannedRide,
    TrackedRide,
    UserContentItem,
    Waypoint,
} from '@polaris-customerweb/sharedcomponents.user-content';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { assign, orderBy } from 'lodash-es';
import { UserContentMenuOption } from 'src/app/components/rides-places/models/user-content-menu-options';
import { UserContentMenuComponent } from 'src/app/components/shared/components/user-content-menu/user-content-menu.component';
import { UserContentSelectListComponent } from 'src/app/components/shared/components/user-content-select-list/user-content-select-list.component';
import { Collection } from 'src/app/models/collection';
import { SelectedItems } from 'src/app/models/selectedItems';
import { UserContentService } from 'src/app/services/user-content.service';

@Component({
    imports: [
        AngularSvgIconModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        UserContentMenuComponent,
        UserContentSelectListComponent,
    ],
    selector: 'rdx-new-post',
    styleUrls: ['./new-post.component.scss'],
    templateUrl: './new-post.component.html',
})
export class NewPostComponent {
    isLoading = false;
    hasSelectedItem = false;
    areGeofencesEnabled: boolean;
    navigationTabs = UserContentMenuOption;
    currentTab = UserContentMenuOption.recent;
    recent: UserContentItem[];
    collections: Collection[];
    geofences: Geofence[];
    plannedRides: PlannedRide[];
    trackedRides: TrackedRide[];
    waypoints: Waypoint[];
    selectedItems = new SelectedItems();

    constructor(
        private configService: ConfigService,
        private matDialogRef: MatDialogRef<NewPostComponent>,
        private userContentService: UserContentService
    ) {
        this.areGeofencesEnabled =
            this.configService.featureFlags.areGeofencesEnabled;
        this.getUserContent();
    }

    close(): void {
        this.matDialogRef.close(this.selectedItems);
    }

    onTabSelected(selectedTab: UserContentMenuOption): void {
        this.currentTab = selectedTab;
    }

    onItemSelected(userContentItem: UserContentItem): void {
        this.selectedItems = SelectedItems.fromUserContent(userContentItem);
        this.hasSelectedItem = true;
    }

    private getUserContent(): void {
        this.isLoading = true;
        this.userContentService
            .getLoggedInUsersContent()
            .subscribe((userContent) => {
                assign(this, userContent);
                const recent = [
                    ...userContent.trackedRides,
                    ...userContent.waypoints,
                    ...userContent.plannedRides,
                    ...userContent.geofences,
                    ...userContent.collections,
                ];
                this.recent = orderBy(
                    recent,
                    ['modificationDate', 'creationDate'],
                    ['desc', 'desc']
                ).slice(0, 10);
                this.isLoading = false;
            });
    }
}
